import {
  Component,
  PLATFORM_ID,
  inject,
  runInInjectionContext,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { IconWrapComponent } from '../../components/icon-wrap-component/icon-component';
import { IconNoWrapComponent } from '../../components/icon-nowrap/icon-component';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { UserService } from '../../services/user.service';
import { Observable, forkJoin, takeUntil, tap } from 'rxjs';
import { User } from '../../interfaces/user.interface';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Clinic } from '../../interfaces/clinic.interface';
import { ClinicService } from '../../services/clinic.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, IconWrapComponent, IconNoWrapComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  host: { ngSkipHydration: 'true' },
})
export class SidebarComponent {
  platformId = inject(PLATFORM_ID);
  isBrowser = isPlatformBrowser(this.platformId);
  userSrv = inject(UserService);
  clinicSrv = inject(ClinicService);
  toastr = inject(ToastrService);
  user$!: Observable<User>;

  routes = {
    employee: '/admin-panel/overview/admin',
    user: '/admin-panel/overview/admin',
    administrator: '/admin-panel/overview/admin',
    owner: '/admin-panel/overview/admin',
  };
  canAddClinic = false;
  powerfulRoles = ['administrator', 'owner'];
  userClinics: Clinic[] = [];
  constructor() {
    if (this.isBrowser) {
      this.user$ = this.userSrv.user$.pipe(
        takeUntilDestroyed(),
        tap((user) => {
          this.canAddClinic = this.powerfulRoles.includes(user.role);
          this.getUserClinics(user);
        })
      );
      setTimeout(() => {
        (window as any).initFlowbite();
      }, 0);
    }
  }
  getUserClinics(user: User) {
    if (!user.availableClinics.length) return;
    forkJoin(
      user.availableClinics.map((c) => this.clinicSrv.getDetails(c))
    ).subscribe({
      next: (clinics) => {
        this.userClinics = clinics;
      },
    });
  }
  hasActiveClinic() {
    if (!this.userSrv.user$.value.activeClinic) {
      this.toastr.error('Изберете активна клиника', '', { timeOut: 5000 });
    }
  }
}
